import { create } from "zustand";
import { IPortfolio } from "@/lib/interfaces and Enums/ENUMPortfolio";
import { ReferenceDataStatus } from "@/lib/interfaces and Enums/ENUMReferenceDataStatus";

// LQC-2254 - portfolios of the originating user, fetched on demand by the Trade
// Creation - New widget (see portfoliosStoreACTIONS). Stays empty and Idle for any
// user who never adds that widget, so the call is never made.

type State = {
  portfolios: IPortfolio[];
  portfoliosStatus: ReferenceDataStatus;
  portfoliosError: string;
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  setPortfolios: (portfolios: IPortfolio[]) => void;
  // eslint-disable-next-line no-unused-vars
  setPortfoliosStatus: (status: ReferenceDataStatus) => void;
  // eslint-disable-next-line no-unused-vars
  setPortfoliosError: (message: string) => void;
  clearPortfolios: () => void;
};

const portfoliosStore = create<State & Action>((set) => ({
  portfolios: [],
  portfoliosStatus: ReferenceDataStatus.Idle,
  portfoliosError: "",

  // A successful load is the only way to Loaded - it also clears any prior error.
  setPortfolios: (portfolios) =>
    set({
      portfolios,
      portfoliosStatus: ReferenceDataStatus.Loaded,
      portfoliosError: "",
    }),
  setPortfoliosStatus: (portfoliosStatus) => set({ portfoliosStatus }),
  setPortfoliosError: (portfoliosError) =>
    set({ portfoliosError, portfoliosStatus: ReferenceDataStatus.Error }),
  clearPortfolios: () =>
    set({
      portfolios: [],
      portfoliosStatus: ReferenceDataStatus.Idle,
      portfoliosError: "",
    }),
}));

export default portfoliosStore;
